export default __webpack_public_path__ + "static/media/19.a96fcfae.png";